exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-class[data-v-8892161e]{background-color:#fff;border-bottom:1px solid #d3d3d3;padding-bottom:10px;margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/DetailHeader.vue?vue&type=style&index=0&id=8892161e&prod&scoped=true&lang=css&
// module id = 1574
// module chunks = 0